import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {WicketUser} from '@tisa-group/models';
import {TISA_WICKET_V2_API_URL} from '../tisa-wicket.providers';

@Injectable({
  providedIn: 'root',
})
export class LegalDocumentsService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_V2_API_URL) readonly wicketV2ApiUrl: string | (() => string),
  ) {}

  getDocument(
    language: WicketUser['preferred_language'],
    documentName: string,
    applicationId: string,
  ) {
    return this.httpClient.get<any>(
      `${
        this.wicketV2ApiUrl instanceof Function
          ? this.wicketV2ApiUrl()
          : this.wicketV2ApiUrl
      }/agreements/files/search`,
      {
        params: {
          language_code: language as string,
          type: documentName,
          application_id: applicationId,
        },
      },
    );
  }
}
